import { Card, Col, Form, Row } from 'react-bootstrap';

// Shared layout for multi-field forms (My Profile, and later Sign Up / admin
// user forms). Labels sit above fields; related fields pair up side by side
// on wide screens (md ≥ 768px) and stack into one column on mobile.
//
// <FormPage title="My Profile" subtitle="* Required field">
//   <Form onSubmit={...}>
//     <FormSection title="Personal">
//       <FormField id="firstName" label="First Name" required half>
//         <Form.Control ... />
//       </FormField>
//     </FormSection>
//   </Form>
// </FormPage>

// Centered, theme-aware card that holds the whole form
export function FormPage({ title, subtitle, children }) {
  return (
    <Row className='justify-content-center'>
      <Col lg={9} xl={8}>
        <h1 style={{ marginTop: '32px' }}>{title}</h1>
        {subtitle && <p className='text-muted mb-3'>{subtitle}</p>}
        <Card className='card--opaque shadow-sm mb-5'>
          <Card.Body className='p-4 p-md-5'>{children}</Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

// Titled group of related fields; children are FormField columns
export function FormSection({ title, description, children }) {
  return (
    <section className='form-section'>
      <h2 className='form-section__title'>{title}</h2>
      {description && <p className='text-muted small mb-3'>{description}</p>}
      <Row className='form-section__fields'>{children}</Row>
    </section>
  );
}

// One labelled field. `half` pairs it with a neighbour on wide screens.
// `help` renders small guidance text under the control.
export function FormField({ id, label, required = false, half = false, help, children }) {
  return (
    <Col xs={12} md={half ? 6 : 12}>
      <Form.Group controlId={id}>
        {label && (
          <Form.Label className='fw-semibold mb-1'>
            {label}
            {required && <span className='form-field__required' aria-hidden='true'> *</span>}
            {required && <span className='visually-hidden'> (required)</span>}
          </Form.Label>
        )}
        {children}
        {help && <Form.Text className='text-muted'>{help}</Form.Text>}
      </Form.Group>
    </Col>
  );
}
